import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, DropdownSort, DropdownItem } from '@weezevent/nacre';

export default function TicketOfficeEventTab({ children, order, setOrder, selectAll, setSelectAll, setSelected }) {
    const { t } = useTranslation();

    return (
        <Table
            basic
            celled
            useNew
            selectable
            onSelectAll={(_, data) => {
                setSelectAll(!selectAll);
                selectAll === true ? setSelected([]) : setSelectAll(true);
            }}
        >
            <Table.THead>
                <Table.Tr isHeader active={selectAll}>
                    <th style={{ width: '170px' }}>
                        <DropdownSort
                            name="crst"
                            active={['crst', `-crst`].includes(order)}
                            label={t('ticket.ticket_offices.events.table.date')}
                            ordering={order}
                            items={[
                                <DropdownItem.Icons
                                    key={1}
                                    item="Croissant"
                                    checked={order === 'crst'}
                                    onClick={() => {
                                        setOrder('crst');
                                    }}
                                />,
                                <DropdownItem.Icons
                                    key={2}
                                    item="Décroissant"
                                    checked={order === '-crst'}
                                    onClick={() => {
                                        setOrder('-crst');
                                    }}
                                />
                            ]}
                        />
                    </th>
                    <th style={{ width: '280px' }}>
                        <DropdownSort
                            name="alpha"
                            active={['alpha', `-alpha`].includes(order)}
                            ordering={order}
                            label={t('ticket.ticket_offices.events.table.event')}
                            items={[
                                <DropdownItem.Icons
                                    key={1}
                                    item="De A à Z"
                                    checked={order === 'alpha'}
                                    onClick={() => {
                                        setOrder('alpha');
                                    }}
                                />,
                                <DropdownItem.Icons
                                    key={2}
                                    item="De Z à A"
                                    checked={order === '-alpha'}
                                    onClick={() => {
                                        setOrder('-alpha');
                                    }}
                                />
                            ]}
                        />
                    </th>
                    <th>{t('ticket.ticket_offices.events.table.rates')}</th>
                    <th>{t('ticket.ticket_offices.events.table.quota')}</th>
                    <th>{t('ticket.ticket_offices.events.table.visible')}</th>
                    <th style={{ width: '100px' }}>{t('ticket.ticket_offices.events.table.actions')}</th>
                </Table.Tr>
            </Table.THead>
            <Table.TBody>{children}</Table.TBody>
        </Table>
    );
}
